import { Space } from 'antd';
import { createContext, FC, useContext, useEffect, useState } from 'react';
import { Form, Key, Select, Button, Tooltip } from '@maxtropy/components';
import styles from './index.module.scss';
import { Dayjs } from 'dayjs';
import SwitchRangePicker from './components/SwitchRangePicker';
import UnitSwiper from './components/UnitSwiper';
import SubUnitTable from './components/SubUnitTable';
import { DateType } from '../prop';
import { DataPeriodListItem, getDataQueryPeriodList } from '@/api/energyOverview';
import { InfoCircleOutlined } from '@ant-design/icons';
import { EnergyUsageCostContext } from '..';
import qs from 'qs';
export const EnergyAnalysisOverviewContext = createContext<{
  time?: RangeValue;
  dataQueryPeriodId?: number;
  timeResolution?: DateType;
}>({});

export interface IEnergyAnalysisOverview {
  groupId: number | undefined;
}

export type RangeValue = [Dayjs | null, Dayjs | null] | null;
const text = `用能成本数据不包含今日的成本数据；且电能-用能成本统计为电度电费统计（仅计算的成本为零售交易电费，计算方式为尖峰平谷电量*对应尖峰平谷时段单价），其中不包含基本电费以及附加电费等。`;
const EnergyAnalysisOverview: FC<IEnergyAnalysisOverview> = props => {
  const [timeResolution, setTimeResolution] = useState<DateType>(DateType.DAY);
  const { groupId } = useContext(EnergyUsageCostContext);

  const [time, setTime] = useState<RangeValue>();
  const [currentUnit, setCurrentUnit] = useState<{ unitName?: string; unitId?: number }>();
  const [dataQueryPeriodId, setDataQueryPeriodId] = useState<number>();
  const [dataPeriodList, setDataPeriodList] = useState<DataPeriodListItem[]>([]);

  const [form] = Form.useForm();

  useEffect(() => {
    setDataQueryPeriodId(undefined);
    form.setFieldValue('dataQueryPeriodId', undefined);
    getDataQueryPeriodList({ startTime: time?.[0]?.valueOf(), endTime: time?.[1]?.valueOf() }).then(res => {
      setDataPeriodList(res.dataPeriodList ?? []);
    });
  }, [timeResolution, time, groupId]);

  const exportAction = () => {
    const params = {
      periodId: dataQueryPeriodId,
      energyUnitGroupId: groupId,
      fromTime: time?.[0]?.valueOf(),
      toTime: time?.[1]?.valueOf(),
      timeResolution: timeResolution,
    };
    window.open(`/api/v2/energy-unit/costExport` + qs.stringify(params, { addQueryPrefix: true }));
  };
  return (
    <EnergyAnalysisOverviewContext.Provider
      value={{
        timeResolution,
        time,
        dataQueryPeriodId,
      }}
    >
      <div className={styles.wrapper}>
        <div className={styles.bg_wrapper}>
          <Form form={form} isOrigin={true} className={styles.topHeadTitle}>
            <Space size={16}>
              {/* 日期选择器 */}
              <SwitchRangePicker
                time={time}
                setTime={setTime}
                setTimeResolution={setTimeResolution}
                timeResolution={timeResolution}
              />
              <Form.Item name="dataQueryPeriodId" label="数据查询时段" style={{ marginBottom: 0 }}>
                <Select
                  placeholder="请选择"
                  style={{ width: 150 }}
                  onChange={(value: number) => setDataQueryPeriodId(value)}
                  options={dataPeriodList.map(item => ({ value: item.id, label: item.name }))}
                  allowClear
                />
              </Form.Item>
              <Tooltip placement="right" title={text}>
                <div className={styles.statisTitle}>
                  <InfoCircleOutlined
                    style={{ fontSize: '14px', marginRight: '6px', color: 'var(--mx-warning-color)' }}
                  />
                  <span className={styles.statisText} style={{ color: 'var(--mx-text-desc-color)' }}>
                    用能成本数据不包含今日的成本数据；且电能-用能成本统计为电度电费统计（仅计算的成本为零售交易电费，计算方式为尖峰平谷电量*对应尖峰平谷时段单价），其中不包含基本电费以及附加电费等。
                  </span>
                </div>
              </Tooltip>
            </Space>
            <Space>
              <Button type="primary" onClick={() => exportAction()}>
                导出
              </Button>
            </Space>
          </Form>
          <UnitSwiper setCurrentUnit={setCurrentUnit} />
        </div>
        <div className={styles.bg_wrapper} style={{ marginTop: '10px', flex: 1 }}>
          <SubUnitTable swiperUnit={currentUnit} />
        </div>
      </div>
    </EnergyAnalysisOverviewContext.Provider>
  );
};

export default EnergyAnalysisOverview;
